import { logger } from "./../_helpers/logger";
// Get user from OIDC storage (always fresh, updated on token renewal).
const getOidcUser = () => {
  logger.debug("Retrieving OIDC user from storage");
  const authority = `${window.REACT_APP_AUTHORITY}${window.REACT_APP_USER_POOL_ID}`;
  const clientId = window.REACT_APP_CLIENT_ID;
  const storageKey = `oidc.user:${authority}:${clientId}`;
  
  const oidcStorage = localStorage.getItem(storageKey);
  if (oidcStorage) {
    try {
      return JSON.parse(oidcStorage);
    } catch (e) {
      logger.error('Failed to parse OIDC user from storage', e);
    }
  }
  return null;
}

export const getBearerAccessToken = () => {
  logger.debug("Retrieving access token for API calls");
  const user = getOidcUser();
  if (user && user.access_token) {
    return 'Bearer ' + user.access_token;
  }
}

export const getAccessToken = () => {
  logger.debug("Retrieving access token for API calls");
  const user = getOidcUser();
  if (user && user.access_token) {
    return user.access_token;
  }
}

export const getCognitoGroups = () => {
  logger.debug("Retrieving Cognito groups from user profile");
  const user = getOidcUser();
  if (user && user.profile) {
    return user.profile["cognito:groups"]
  }
}

export const getUserType = () => {
  logger.debug("Determining user type from Cognito groups");
  const user = getOidcUser();
  if (user && user.profile) {
    let group_str = user.profile["cognito:groups"].filter((group) => group.indexOf("user_type") >= 0).toString()
    return group_str.split(":")[1]
  }
}

export const getUserId = () => {
  logger.debug("Retrieving user ID from OIDC user profile");
  const user = getOidcUser();
  if (user && user.profile) {
    return user.profile["cognito:username"]
  }
}
